import {codeData,qrcodeData,wxBind,accountLogin,codeLogin,register,userinfoData,ucenterMenu} from "../../../api/main/login.js";
import config from "@/assets/js/conf/config";

let modules = {
	namespaced: true,
	state: {
		userinfo:localStorage['userinfo']?JSON.parse(localStorage['userinfo']):"",
		auth:localStorage["auth"]?localStorage["auth"]:"",
		token:localStorage[config.tokenKey]?localStorage[config.tokenKey]:"",
		permissionsLoaded:false,
		is_host :localStorage['is_host']?localStorage['is_host']:false,
		user_level :localStorage['user_level'] ? Number(localStorage['user_level']) || 9 : 9,
		ucmenu :localStorage['ucmenu']?JSON.parse(localStorage['ucmenu']):[],
		// avatar:localStorage["avatar"]?localStorage["avatar"]:"",
		// ucmenu:localStorage['ucmenu']&&localStorage['ucmenu']!='null'?JSON.parse(localStorage['ucmenu']):[{url:'./','menu_id':0,title:'账号未授权'}],
		avatar:require('@/assets/images/avatar_default.png'),
		defaultUcmenu:[
			{
				"menu_id": 113,
				"title": "店铺管理",
				"icon": "icon-shouye",
				"url": "/ucenter_legacy"
			},
			{
				'icon':"icon-walletY",
				'menu_id':133,
				'title':"店铺数据",
				'url':"./uc_statistic"
			},
			{
				'icon':"el-icon-data-analysis",
				'menu_id':134,
				'title':"运营大厅",
				'url':"",
				'children':[
					{
						'menu_id':1341,
						'title':"店铺看板",
						'url':"/uc_shop_board"
					},
					{
						'menu_id':1342,
						'title':"商品看板",
						'url':"/uc_product_board"
					},
					{
						'menu_id':1343,
						'title':"任务大厅",
						'url':"/uc_task_hall"
					}
				]
			},
			{
				"menu_id": 120,
				"title": "我的商品",
				"icon": "icon-guanli",
				"url": "/uc_goods"
			},
			{
				"menu_id": 126,
				"title": "抖店优化",
				"icon": "icon-guanli",
				"url": "/uc_dd_host"
			},
			{
				"menu_id": 131,
				"title": "云商品库",
				"icon": "icon-fenlei2",
				"url": "/uc_product"
			},
            {
				'icon':"el-icon-star-off",
				'menu_id':135,
				'title':"商品优化",
				'url':"./uc_optimization"
			},
			// {
			// 	"menu_id": 132,
			// 	"title": "检测管理",
			// 	"icon": "icon-fenlei",
			// 	"url": "/uc_check"
            // },
            // {
			// 	"menu_id": 132,
			// 	"title": "检测管理",
			// 	"icon": "icon-fenlei",
			// 	"url": "/uc_check"
			// },
			{
				'icon':"icon-fenlei",
				'menu_id':132,
				'title':"检测管理",
				'url':"",
				'children':[
					{
						'menu_id':1321,
						'title':"检测管理",
						'url':"/uc_check"
					},
					{
						'menu_id':1322,
						'title':"低价引流检测",
						'url':"/uc_checkSku"
					}
				]
			},
			{
				"menu_id": 117,
				"title": "上架策略",
				"icon": "icon-shangjia",
				"url": "/uc_shangjia"
			},
			{
				"menu_id": 130,
				"title": "资源盲盒",
				"icon": "icon-xingli",
				"url": "/uc_blindBox"
			},
			{
				'menu_id': 115,
				'icon': "icon-dingdan2",
				'title': "订单管理",
				'url': "/uc_order"
			},
			{
				'menu_id': 175,
				'icon': "icon-dingdan2",
				'title': "微信订单",
				'url': "/uc_order_wx"
			},
			{
				'menu_id': 136,
				'icon': "icon-dingdan2",
				'title': "售后管理",
				'url': "/uc_after_sales"
			},
			{
				'menu_id': 137,
				'icon': "icon-shezhi1",
				'title': "售后地址",
				'url': "/uc_after_sale_address"
			},
			{
				'icon':"icon-cart",
				'menu_id':128,
				'title':"采购管理",
				'url':"./uc_pdd_manage"
			},
            {
				'icon':"el-icon-s-check",
				'menu_id':138,
				'title':"报销管理",
				'url':"./uc_reimbursement"
			},
            {
				'icon':"el-icon-s-ticket",
				'menu_id':139,
				'title':"工单管理",
				'url':"./uc_ticket"
			},
			{
				"menu_id": 116,
				"title": "我的钱包",
				"icon": "icon-qianbao",
				"url": "/uc_wallet"
            },
            {
				"menu_id":129,
				"title":"岗位管理",
				"icon":"el-icon-tickets",
				"url":"/uc_position"
			},
			{
				"menu_id":127,
				"title":"员工管理",
				"icon":"el-icon-office-building",
				"url":"/uc_employee"
			},
			{
				"menu_id": 118,
				"title": "个人设置",
				"icon": "icon-shezhi1",
				"url": "/uc_setting"
			},
/*			{
				"menu_id": 125,
				"title": "修改密码",
				"icon": "el-icon-edit",
				"url": "/uc_pwd"
			}*/
		]
	},
	mutations: {
		["SET_USER"](state,payload){
			state.userinfo = payload.userinfo
			state.permissionsLoaded = true
			state.auth = payload.auth
			localStorage["userinfo"]=JSON.stringify(payload.userinfo)
			localStorage["auth"]=payload.auth
			let level = 9
			const { user_level, level_expire_date } = payload.userinfo || {}
			const userLevel = Number(user_level)
			if (level_expire_date && [1, 2].includes(userLevel)) {
				const expireTime = new Date(level_expire_date).getTime()
				if (expireTime > Date.now()) level = userLevel
			}
			state.user_level = level
			localStorage["user_level"] = level
			if(payload.userinfo&&payload.userinfo.avatar){
				state.avatar = payload.userinfo.avatar
				localStorage["avatar"]=payload.userinfo.avatar
			}
		},
		["SET_USER_LEVEL"](state, level){
			const resolvedLevel = Number(level)
			state.user_level = [1, 9].includes(resolvedLevel) ? resolvedLevel : 9
			localStorage["user_level"] = state.user_level
		},
		['SET_TOKEN'](state,payload){
			state.token = payload.token
			localStorage[config.tokenKey]=payload.token
			localStorage[config.refreshTokenKey]=payload.re_token
			localStorage[config.tokenExpires]=payload.token_ex

		},
		["OUT_LOGIN"](state){
			state.userinfo = ""
			state.auth = ""
			state.avatar = ""
			state.ucmenu = []
			state.token = ""
			state.permissionsLoaded = false
			localStorage.removeItem("userinfo")
			localStorage.removeItem("auth")
			localStorage.removeItem("avatar")
			localStorage.removeItem("ucmenu")
			localStorage.removeItem("user_level")
			localStorage.removeItem(config.tokenKey)
			localStorage.removeItem(config.refreshTokenKey)
		},

		["SET_USERAVATAR"](state,payload){
			localStorage["avatar"]=payload.avatar
		},
		["SET_UCMENU"](state,payload){
			state.is_host = payload?.is_host??state.is_host
			localStorage["is_host"]=payload?.is_host??state.is_host
			let menuData = state.defaultUcmenu.filter(item => item.menu_id!=127||(item.menu_id==127&&state.is_host));
			state.ucmenu = menuData
			localStorage["ucmenu"]=JSON.stringify(menuData)
		}
	},
	actions: {
		getCodeData(conText, payload){//获取手机短信验证码
			codeData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getQrcodeData(conText, payload){//获取二维码
			qrcodeData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		checkWxBind(conText, payload){//检测微信绑定
			wxBind(payload.data).then(res => {
				if(res.code==200){
					conText.commit("SET_USER",{userinfo:res.data.userinfo,auth:res.data.auth})
				}
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		DoAccountLogin(conText, payload){//账号密码登录
			accountLogin(payload.data).then(res => {
				if(res.code==200){
					const expiresAt = Date.now() + (res.data.expire_at * 1000)
					conText.commit("SET_TOKEN",{token:res.data.access_token,re_token:res.data.refresh_token,token_ex:expiresAt})
					conText.commit('SET_UCMENU',{is_host:res.data.is_host})
				}
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		DoCodeLogin(conText, payload){//短信验证码登录
			codeLogin(payload.data).then(res => {
				if(res.code==200){
					const expiresAt = Date.now() + (res.data.expire_at * 1000)
					conText.commit("SET_TOKEN",{token:res.data.access_token,re_token:res.data.refresh_token,token_ex:expiresAt})
					conText.commit('SET_UCMENU',{is_host:res.data.is_host})
				}
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		DoRegister(conText, payload){//账户注册
			register(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getUserinfoData(conText, payload){//获取个人信息
			return userinfoData(payload.data).then(res => {
				if(res.code==200){
					conText.commit("SET_USER",{userinfo:res.data})
					conText.commit('SET_UCMENU')
				}
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getUcenterMenu(conText, payload){//获取菜单权限
			return ucenterMenu(payload.data).then(res => {
				if(res.status==200){
					conText.commit("SET_UCMENU",{ucmenu:res.data})
				}
				if (payload.success) {
					payload.success(res)
				}
			})
		},
	}

}
export default modules;
